import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { KBSettingsPage } from "@client/components/kb/kb-settings-page";
import { isCompilationKind } from "@client/components/kb/knowledge-compilation-kinds";

const SETTINGS_TABS = [
  "basic", "chunk", "index", "metadata", "classifications",
  "retrieval", "compilation", "collaborators", "audit", "sources",
] as const;
type SettingsTab = (typeof SETTINGS_TABS)[number];
const SETTINGS_TAB_SET = new Set<string>(SETTINGS_TABS);

function isValidSettingsTab(v: unknown): v is SettingsTab {
  return typeof v === "string" && SETTINGS_TAB_SET.has(v);
}

/** 知识编译页签内的三个子 Tab */
export type CompilationCtab = "config" | "runs" | "artifacts";

function isCompilationCtab(v: unknown): v is CompilationCtab {
  return v === "config" || v === "runs" || v === "artifacts";
}

export const Route = createFileRoute("/_app/kb/$kbId/settings")({
  validateSearch: (search: Record<string, unknown>) => {
    const tab: SettingsTab = search.tab === "dimensions" || search.tab === "semantic"
      ? "classifications"
      : isValidSettingsTab(search.tab) ? search.tab : "basic";
    return {
      tab,
      // 子 Tab 与产物路径仅在知识编译页签内存在，离开时由条件输出剔除
      ...(tab === "compilation" ? {
        ctab: isCompilationCtab(search.ctab) ? search.ctab : "config",
        // kind 只在 URL 显式指定时保留：缺省的「落到哪条路径」由产物页按有无产物决定
        ...(isCompilationKind(search.kind) ? { kind: search.kind } : {}),
      } : {}),
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { kbId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: "/kb/$kbId/settings" });
  return (
    <KBSettingsPage
      kbId={kbId}
      activeTab={tab}
      onTabChange={(t) => navigate({ search: (prev) => ({ ...prev, tab: t }), replace: true })}
    />
  );
}
